import React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { createStyles, makeStyles, withStyles } from '@mui/styles';
import { Stack } from '@mui/system';
import { useIntl } from 'react-intl';

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      '& .MuiDataGrid-virtualScrollerRenderZone': {
        '& .MuiDataGrid-row': {
          color: theme.palette.mode === 'dark' ? 'white' : 'black', // Default text color for all rows
          '&:nth-child(2n)': {
            backgroundColor: theme.palette.mode === 'dark' ? 'rgba(50, 50, 50, .7)' : 'rgba(235, 235, 235, .7)', // Alternate row background color based on theme mode
            color: theme.palette.mode === 'dark' ? 'white' : 'black', // Text color for alternate rows
          },
        },
      },
    },
    statusLightRed: {
      backgroundColor: 'rgba(255, 200, 200, 0.5) !important', // Light red with some transparency
      color: theme.palette.mode === 'dark' ? 'white' : 'black', // Ensure text is readable
    },
  })
);

export default function UsableTable(props) {
  const intl = useIntl();

  const { records, 
    columns,
     pageSize, 
    rowPerPage, 
    campoPesquisa, 
    firstNameSearch, 
    totalRows } = props;

  const classes = useStyles(props);
  const recordsArray = records?.data;

  
  const recordsWithRowNumber = Array.isArray(records)
  ? records.map((record, index) => ({
      ...record,
      rowNumber: index + 1,
    }))
  : [];


  // Filter columns based on visibility flags
  const visibleColumns = columns.filter(column => column.visible !== false);
  
  return (
    // <ThemeProvider theme={dataGridTheme}>
      <DataGrid
        className={classes.root}
        rows={recordsWithRowNumber}
        disableSelectionOnClick
        columns={visibleColumns}

       //  columns={columns}
        pageSize={pageSize}
        rowsPerPageOptions={[rowPerPage]}
       // rowCount={totalRows}  // Set this value
        /* onPageChange={(params) => {
          alert("chamge oage 1")
          if (props.onPageChange) {
              props.onPageChange(params.page, params.pageSize);
          }
      }} */
      //  paginationMode="server"
        autoHeight
        disableExtendRowFullWidth
        rowHeight={35}
        headerHeight={40}
        components={{
          NoRowsOverlay: () => (
            <Stack height="100%" alignItems="center" justifyContent="center">
              {intl.formatMessage({ id: 'aucun_enregistrement_trouve' })}
            </Stack>
          ),
        }}
        filterModel={{
          items: [
            {
              columnField: campoPesquisa,
              operatorValue: 'contains',
              value: firstNameSearch,
            },
          ],
        }}
      />
    // </ThemeProvider>
  );
}
